module.exports = __webpack_public_path__ + "static/img/bg.7fc0552d.png";